import { ArrowUpward, EscalatorWarningRounded } from '@mui/icons-material'
import { Card, CardContent, CardHeader, IconButton, Paper, Typography } from '@mui/material'
import SimpleTable from 'common/components/SimpleTable'
import Table from 'common/components/Table'
import ScrollHelper from 'common/libs/ScrollHelper'
import ThemeManager from 'theming/ThemeManager'

/**
 *
 * @param {Object} props
 * @param {Model145DTO} props.data - The user to show the data
 */
const Model145ParentsData = ({ data }) => {
  const ascendants = data?.irpf_da_ascendentes ?? []
  const Theme = new ThemeManager()
  return (
    <Paper>
      <Card>
        <CardHeader
          avatar={<EscalatorWarningRounded />}
          sx={{
            backgroundColor: 'background.lighter',
            boxShadow: 'none',
          }}
          title="Mayores"
          action={
            <IconButton onClick={() => ScrollHelper.scrollTo({ id: 'model145-intro' })}>
              <ArrowUpward />
            </IconButton>
          }
        />
        <CardContent>
          <Typography sx={{ my: 1 }} variant="subtitle1">
            {
              'Datos de los ascendientes mayores de 65 años (o menores de dicha edad si son discapacitados) que conviven con Vd. durante, al menos, la mitad del año y que no tienen rentas anuales superiores a 8.000 euros.'
            }
          </Typography>
          <Table
            count={ascendants?.length}
            dataSource={ascendants}
            header_style={{
              backgroundColor: Theme.pallete?.primary?.main,
              color: Theme.pallete.primary.contrastText,
            }}
            stripped={true}
            header_cell_style={{ padding: '10px', textAlign: 'center' }}
            table_style={{ width: '100%', borderCollapse: 'collapse' }}
            container_style={{ borderRadius: '5px', marginBottom: '5px' }}
            generic_cell_style={{
              textAlign: 'center',
              padding: '15px 10px',
            }}
            fields={[
              { title: 'Año nacimiento', field: 'ejer_nacimiento' },
              {
                title: 'Año de adopcion o recogimiento',
                field: 'ejer_adopcion',
              },
              {
                title: 'Grado igual o superior al 33% e inferior al 65%',
                field: 'disability_1',
                customGetter: (row) => {
                  return row.tipo_discapacidad === '01' ? 'Si' : 'No'
                },
              },
              {
                title: 'Grado igual o superior al 65%',
                field: 'disability_2',
                customGetter: (row) => {
                  return row.tipo_discapacidad === '02' ? 'Si' : 'No'
                },
              },
              {
                title:
                  'Además, tiene acreditada la necesidad de ayuda de terceras personas o movilidad reducida',
                field: 'disability_3',
                customGetter: (row) => {
                  return row.tipo_discapacidad === '03' ? 'Si' : 'No'
                },
              },
            ]}
          />
        </CardContent>
      </Card>
    </Paper>
  )
}

export default Model145ParentsData
